module.exports = __webpack_public_path__ + "static/media/SWSCRC6-42.16da370f.mp3";